module.exports = __webpack_public_path__ + "img/voffice-logo.adf3ba17.png";